<nb-user (click)="uploader.click()" size="giant" [name]="userModel?.userName"
    [picture]="pictureHeadShot||currentPicture" onlyPicture id="nb-user-headshot" 
    style="align-items: center; justify-content: center;">
</nb-user>
<input type="file" accept="image/*" hidden #uploader (change)="fileChangeEvent($event)">